import { ChatMessage } from "@/context/SAMChatContext";
import { FlowiseChatSession } from "@/lib/flowise/types";

export interface AuditMetadata {
  type: "audit";
  auditId: number;
  templateTitle: string;
}

export interface Conversation {
  id: string;
  title: string;
  messages: ChatMessage[];
  session: FlowiseChatSession;
  createdAt: Date;
  updatedAt: Date;
  metadata?: AuditMetadata; // Optional audit linking
  // Backend session persistence fields
  backendSessionId?: number; // ID from core-api SamSession table
  isSyncedToBackend?: boolean; // Whether this conversation has been synced to backend
  needsHydration?: boolean; // True for skeleton conversations restored from backend (messages not yet loaded)
}

export const generateConversationTitle = (messages: ChatMessage[]): string => {
  // Get all user messages
  const userMessages = messages.filter((msg) => msg.sender === "user");

  if (userMessages.length === 0) {
    return "New Conversation";
  }

  // Use the first user message for the title (represents the conversation topic)
  const firstUserMessage = userMessages[0];
  const title = firstUserMessage.text.substring(0, 50);
  return title.length < firstUserMessage.text.length ? `${title}...` : title;
};
